export interface TrackParms {
  bizType: string
  pageLevelId: string
  clickId?: string
  logType?: string
  pageParam?: any
  positionId?: string
  positionParam?: any
}

/* 上报事件/页面埋点 */
export const trackClick = (options: TrackParms) => {
  const {
    bizType,
    pageLevelId,
    clickId,
    positionId,
    logType = '20000'
  } = options
  let { pageParam, positionParam } = options
  pageParam = pageParam ? JSON.stringify(pageParam) : undefined
  positionParam = positionParam ? JSON.stringify(positionParam) : undefined
  try {
    const params = {
      bizType, // 业务类型
      pageLevelId, // 页面 ID
      clickId, // 事件编码
      logType, // 上报类型: '10000'页面、'20000'事件
      pageParam, // 页面参数
      positionId, // 坑位编码
      positionParam // 坑位内容参数
    }
    // 手动上报统一使用单对象参数调用方式，更清晰
    window.track && window.track._launch(params)
  } catch (e) {
    console.error(e)
  }
}

/* 上报页面埋点 */
export const trackView = (options: TrackParms) => {
  const { bizType, pageLevelId, positionId, pageParam, positionParam } = options
  const params = {
    bizType,
    pageLevelId,
    logType: '10000',
    pageParam,
    positionId,
    positionParam
  }
  trackClick(params)
}

export function setBaiduTrack() {
  setTimeout(() => {
    ;(function () {
      //百度统计 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') &&
        document.getElementById('baidu_tj')?.remove()
      const hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?e14cf5c7ca235cccda52eb729d1fde8e'
      hm.id = 'baidu_tj'
      const s = document.getElementsByTagName('script')[0]
      s.parentNode?.insertBefore(hm, s)
    })()
  }, 0)
}
